import { render } from "./loading-screen.vue?vue&type=template&id=40cb427e&scoped=true"
const script = {}

import "./loading-screen.vue?vue&type=style&index=0&id=40cb427e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-40cb427e"

export default script